var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import './index.css'; // Ensure this points to your CSS
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
// import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { HelmetProvider } from 'react-helmet-async'; // <--- IMPORT THIS
var appName = ((_a = window.document.getElementsByTagName('title')[0]) === null || _a === void 0 ? void 0 : _a.innerText) || 'TableOp';
createInertiaApp({
    title: function (title) { return "".concat(title, " - ").concat(appName); },
    // Lazy-load each page as its own webpack chunk (code-splitting) so the
    // initial bundle only ships the code for the page actually being viewed,
    // instead of every page (POS, kitchen, pricing, blog, ...) at once.
    resolve: function (name) { return import("./pages/".concat(name, ".tsx")).then(function (module) { return module.default; }); },
    setup: function (_a) {
        var el = _a.el, App = _a.App, props = _a.props;
        var root = createRoot(el);
        root.render(
        // WRAP YOUR APP IN HELMET PROVIDER
        _jsx(HelmetProvider, { children: _jsx(App, __assign({}, props)) }));
    },
});
